export const WebSocketEvents = {
  trainingChange: 'training:change',
  notificationCreated: 'notification:created',
  subscriptionActivated: 'subscription:activated',
} as const;

export const TrainingChangeTypes = {
  createdForOwner: 'createdForOwner',
  changedForOwner: 'changedForOwner',
  changedForCreator: 'changedForCreator',
  sharedWithUser: 'sharedWithUser',
  exerciseDeletedForOwner: 'exerciseDeletedForOwner',
  exerciseDeletedForCreator: 'exerciseDeletedForCreator',
} as const;

export type TrainingChangeType =
  (typeof TrainingChangeTypes)[keyof typeof TrainingChangeTypes];

export interface ITrainingChangeEventPayload {
  type: TrainingChangeType;
  trainingId: string;
  actorId?: string;
  ownerId?: string;
  creatorId?: string;
  recipientUserId?: string;
}

export const getChatMessageEvent = (chatId: string) => `chatMessage-${chatId}`;
export const getChatTypingEvent = (chatId: string) => `chatTyping-${chatId}`;
